
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetorameshwaramcab() {



    const cardData =
    {
        keyword: 'Pune to Rameshwaram cab ',
        heading: 'Platinum24 Cabs: Pune to Rameshwaram cab',
        headingDescription: ' Platinum24 Cabs provides trusted Pune to Rameshwaram cab services, perfect for pilgrims, families, and long-distance travelers heading to the sacred Ramanathaswamy Temple. Whether you’re seeking a spiritual darshan, exploring the Pamban Bridge, or visiting Dhanushkodi’s serene shores, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey. With professional chauffeurs, timely pickups, and transparent pricing, we make your religious and leisure travel hassle-free. From one-way rides to customized return trip packages, Platinum24 Cabs guarantees reliable service and a memorable Pune to Rameshwaram travel experience.',

        top: 'Top Places to Visit in Rameshwaram with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Ramanathaswamy Temple",
    "description": "The Ramanathaswamy Temple, one of the 12 Jyotirlingas, is Rameshwaram’s holiest shrine. Dedicated to Lord Shiva, it is renowned for its magnificent corridors, sculpted pillars, and sacred water tanks (theerthams). Pilgrims believe a visit here completes the Char Dham Yatra. The temple’s Dravidian architecture is awe-inspiring. Thousands gather daily for darshan and rituals. It is Rameshwaram’s spiritual crown jewel."
  },
  {
    "title": "Agni Theertham",
    "description": "Agni Theertham, located on the seashore near the Ramanathaswamy Temple, is one of the 64 sacred baths. Devotees take a dip here before entering the temple, believing it purifies sins. Sunrise views are mesmerizing from this ghat. Rituals for ancestors are performed by many pilgrims. The site holds deep spiritual value in Hindu tradition. Agni Theertham is Rameshwaram’s sacred coastal ritual site."
  },
  {
    "title": "Pamban Bridge",
    "description": "Pamban Bridge, India’s first sea bridge, connects Rameshwaram to mainland India. This engineering marvel opens up to allow ships to pass. The views of the turquoise sea from the bridge are breathtaking. Tourists often stop to witness trains crossing over the ocean. It symbolizes human ingenuity meeting natural beauty. Pamban Bridge is Rameshwaram’s iconic gateway."
  },
  {
    "title": "Dhanushkodi",
    "description": "Dhanushkodi, known as the ‘Ghost Town,’ was destroyed in the 1964 cyclone. Located at the tip of Rameshwaram, it is where the Bay of Bengal meets the Indian Ocean. Ruins of churches, railway stations, and homes still stand. It is also linked to the Ramayana, where Lord Rama built the Ram Setu. The untouched beauty of the place fascinates travelers. Dhanushkodi is Rameshwaram’s mystical seashore town."
  },
  {
    "title": "Lakshmana Theertham",
    "description": "Lakshmana Theertham is a holy pond dedicated to Lord Lakshmana. It is believed that he performed penance here. The temple nearby has beautiful sculptures depicting Ramayana scenes. Pilgrims take a sacred dip in its waters. Religious rituals are performed here during festivals. The site combines devotion with heritage. Lakshmana Theertham is Rameshwaram’s revered spiritual pond."
  },
  {
    "title": "Gandhamadhana Parvatham",
    "description": "Gandhamadhana Parvatham is a small hillock offering panoramic views of Rameshwaram town. It houses a two-storey temple with Lord Rama’s footprints imprinted on a chakra. Devotees believe Rama stood here before building the Ram Setu. The cool breeze and scenic beauty make it a peaceful retreat. Sunrise and sunset views are stunning. Gandhamadhana Parvatham is Rameshwaram’s spiritual viewpoint."
  },
  {
    "title": "Villoondi Theertham",
    "description": "Villoondi Theertham, meaning ‘buried bow,’ is linked to the Ramayana. It is believed Lord Rama shot an arrow here to bring fresh water for Sita. The site has a freshwater spring amidst the sea. Devotees consider it sacred and miraculous. The calm surroundings add to its charm. Villoondi Theertham is Rameshwaram’s divine coastal spring."
  },
  {
    "title": "Five-Faced Hanuman Temple",
    "description": "This temple is dedicated to Lord Hanuman in his Panchamukha (five-faced) form. It houses the floating stones believed to be used in building the Ram Setu. The temple’s spiritual aura attracts pilgrims from across India. Devotees seek blessings of strength and courage here. Religious chants add to its divine atmosphere. The Panchamukha Hanuman Temple is Rameshwaram’s symbol of devotion and mythology."
  },
  {
    "title": "Kothandaramaswamy Temple",
    "description": "The Kothandaramaswamy Temple, located near Dhanushkodi, is associated with Vibhishana, Ravana’s brother, surrendering to Lord Rama. It is the only structure that survived the 1964 cyclone. Murals inside depict Ramayana episodes. The temple’s coastal setting is scenic and spiritual. Pilgrims include it in their Rameshwaram darshan. Kothandaramaswamy Temple is Rameshwaram’s historic mythological shrine."
  },
  {
    "title": "Adam’s Bridge (Ram Setu)",
    "description": "Adam’s Bridge, or Ram Setu, is a chain of limestone shoals between India and Sri Lanka. According to mythology, it was built by Lord Rama’s army to reach Lanka. Though now submerged, it remains a site of great cultural and religious importance. Aerial views from Dhanushkodi reveal its alignment. It connects faith with geography. Ram Setu is Rameshwaram’s legendary link to the Ramayana."
  }
],


                        "services": [
    {
      "name": "Pune to Rameshwaram Cab",
      "description": "Travel comfortably and safely from Pune to the sacred town of Rameshwaram with our dedicated Pune to Rameshwaram Cab service. Whether you are planning a spiritual pilgrimage or a leisure trip, our fleet of modern, air-conditioned vehicles ensures a smooth and pleasant journey over the long distance. Our experienced drivers are skilled at navigating highways and rural roads, offering you a stress-free travel experience. With flexible pickup and drop-off points, real-time vehicle tracking, and 24/7 customer support, your trip to this holy city becomes seamless and hassle-free."
    },
    {
      "name": "Book Pune to Rameshwaram Taxi",
      "description": "Booking your taxi from Pune to Rameshwaram has never been easier. Use our intuitive online platform to select your preferred vehicle type, choose your pickup time, and confirm your booking instantly. Our Pune to Rameshwaram Taxi service caters to individuals, families, and groups seeking reliable, punctual, and comfortable transportation. All our vehicles are regularly sanitized and maintained to ensure the highest standards of safety and hygiene, making your spiritual journey both safe and enjoyable."
    },
    {
      "name": "Pune to Rameshwaram Car Rental",
      "description": "Opt for our Pune to Rameshwaram Car Rental service to enjoy complete freedom and flexibility on your trip. Choose from a range of vehicles, including compact cars, sedans, and SUVs, available on self-drive or chauffeur-driven options. Our rental cars are well-maintained, fuel-efficient, and equipped with modern amenities to enhance your travel comfort. Whether for a short trip or an extended stay in Rameshwaram, our rental service is designed to meet your unique travel needs with transparent pricing and seamless booking."
    },
    {
      "name": "Pune to Rameshwaram One Way Cab",
      "description": "Take advantage of our Pune to Rameshwaram One Way Cab service for cost-effective and convenient one-direction travel. Ideal for travelers who want to avoid round-trip fares or have onward plans from Rameshwaram, this service offers flexible scheduling and transparent pricing. Our fleet includes a variety of vehicle types to suit solo travelers, families, or groups. Drivers are professional, experienced, and committed to providing a safe and pleasant ride over the long distance between Pune and Rameshwaram."
    },
    {
      "name": "Affordable Cab Pune to Rameshwaram",
      "description": "Travel affordably without compromising on comfort or quality with our Affordable Cab Pune to Rameshwaram service. Perfect for budget-conscious pilgrims and tourists, our economical fares come with no hidden charges and include well-maintained vehicles driven by skilled chauffeurs. We offer seasonal discounts and special packages to ensure you get the best value for your long-distance trip. Our customer-centric approach guarantees reliable pickups, punctual arrivals, and smooth journeys throughout the route."
    },
    {
      "name": "Pune to Rameshwaram Outstation Taxi",
      "description": "Our Pune to Rameshwaram Outstation Taxi service is tailored for long-distance travelers who require dependable transportation across state lines. Whether you are traveling for pilgrimage, vacation, or family visits, our vehicles provide ample space, comfort, and safety for your journey. Drivers are experienced in managing highway travel, tolls, and road regulations. We offer flexible booking options, 24/7 support, and real-time updates to keep you informed and assured from Pune to Rameshwaram and back."
    },
    {
      "name": "Rameshwaram to Pune Cab",
      "description": "For your return journey, rely on our Rameshwaram to Pune Cab service that ensures timely and comfortable travel back home. Our professional chauffeurs provide courteous service and maintain high standards of vehicle cleanliness and safety. Whether you require an early morning pickup or late-night ride, we operate round-the-clock to meet your schedule. Enjoy hassle-free booking, transparent pricing, and reliable transportation from the holy town of Rameshwaram to Pune."
    },
    {
      "name": "Pune to Rameshwaram Cab Booking Online",
      "description": "Book your Pune to Rameshwaram cab easily online through our user-friendly platform. With just a few clicks, select your vehicle, travel date, and pickup location, and receive instant booking confirmation. Our system supports secure payment options and real-time updates on your ride status. Customer support is available 24/7 to assist with any queries or changes to your booking, making your journey planning smooth and stress-free."
    },
    {
      "name": "Pune to Rameshwaram Temple Cab",
      "description": "Designed specifically for pilgrims, our Pune to Rameshwaram Temple Cab service offers convenient transport directly to the famous Ramanathaswamy Temple and other sacred sites in Rameshwaram. Our vehicles provide a quiet, comfortable atmosphere to prepare for your spiritual experience. Drivers are respectful, knowledgeable about the temple vicinity, and ready to assist with special requests such as extra stops or luggage handling. Enjoy a stress-free pilgrimage with reliable and punctual service focused on your devotion and comfort."
    }
  ],
  "tableData": [
    ["Pune to Rameshwaram Cab", "Book Pune to Rameshwaram Taxi"],
    ["Pune to Rameshwaram Car Rental", "Pune to Rameshwaram One Way Cab"],
    ["Affordable Cab Pune to Rameshwaram", "Pune to Rameshwaram Outstation Taxi"],
    ["Rameshwaram to Pune Cab", "Pune to Rameshwaram Cab Booking Online"],
    ["Pune to Rameshwaram Temple Cab"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Rameshwaram Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs offers comfortable and trustworthy cab services from Pune to Rameshwaram, ensuring a smooth and pleasant journey."
  },
  {
    "WhyChooseheading": "Wide Selection of Vehicles for Your Convenience",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers suitable for your Pune to Rameshwaram travel needs."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe and hygienic environment throughout your trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with the Pune to Rameshwaram route to ensure timely and hassle-free travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares including tolls, fuel, and driver allowances for a worry-free Pune to Rameshwaram cab experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with your Pune to Rameshwaram cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to Your Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans customized for your Pune to Rameshwaram journey."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Rameshwaram cab quickly and securely through our website or app with immediate confirmation."
  }
]




























    }

    
const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Rameshwaram cab services?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services from Pune to Rameshwaram with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Rameshwaram?',
        answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Rameshwaram travel?',
        answer: 'We provide hatchbacks, sedans, SUVs, and luxury cars to suit your travel preferences and group size.',
    },
    {
        question: 'Is one-way cab service available from Pune to Rameshwaram?',
        answer: 'Yes, both one-way and round-trip cab services are available for Pune to Rameshwaram travel.',
    },
    {
        question: 'Are the drivers experienced for Pune to Rameshwaram long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, professional, and familiar with the Pune to Rameshwaram route.',
    },
    {
        question: 'Can I customize pickup and drop-off locations in Pune and Rameshwaram?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points according to your convenience.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Rameshwaram cabs?',
        answer: 'All vehicles are regularly sanitized, and drivers adhere to strict safety and hygiene measures to ensure passenger safety.',
    },
    {
        question: 'Is Pune to Rameshwaram cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Rameshwaram cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Rameshwaram cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and major credit/debit cards for hassle-free payments.',
    },
    {
        question: 'Are customizable packages available for Pune to Rameshwaram cab service?',
        answer: 'Yes, we offer flexible and customizable packages tailored to your travel itinerary and preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rajesh Kumar',
        feedback: 'My Pune to Rameshwaram trip was smooth and comfortable thanks to Platinum24 Cabs.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anitha Rao',
        feedback: 'Professional drivers and excellent service made my Pune to Rameshwaram journey memorable.',
        rating: 5,
    },
];
















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToRameshwaramCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Rameshwaram Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-rameshwaram-cab.jpg",
  "description": "Book Pune to Rameshwaram cab service with Platinum24 Cabs. Reliable and affordable taxis for temple visits, one-way trips, and outstation travel. Comfortable rides available 24/7 with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "11999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-rameshwaram-cab-service"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Rameshwaram Cab Service | Affordable Temple Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Rameshwaram cab service with Platinum24 Cabs. Reliable and affordable taxis for temple visits, one-way trips, and outstation travel. Comfortable rides available 24/7 with professional drivers."
  />
  <meta
    name="keywords"
    content="Pune to Rameshwaram Cab, Book Pune to Rameshwaram Taxi, Pune to Rameshwaram Car Rental, Pune to Rameshwaram One Way Cab, Affordable Cab Pune to Rameshwaram, Pune to Rameshwaram Outstation Taxi, Rameshwaram to Pune Cab, Pune to Rameshwaram Cab Booking Online, Pune to Rameshwaram Temple Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToRameshwaramCabSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/113.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetorameshwaramcab;